import request from '@/plugins/request';
const Setting = require('@/setting.env');

// 联盟链管理模块


// 获取链权限 - 参与组织列表
export function GetAuthOrgList(data) {
    return request({
        url: '/chainmaker?cmb=GetAuthOrgList',
        method: 'post',
        data
    });
}

// 获取链权限 - 参与角色列表
export function GetAuthRoleList(data) {
    return request({
        url: '/chainmaker?cmb=GetAuthRoleList',
        method: 'post',
        data
    });
}


// 获取虚拟机类型
export function GetRuntimeTypeList(data) {
    return request({
        url: '/chainmaker?cmb=GetRuntimeTypeList',
        method: 'post',
        data
    });
}

// 上传文件
export function UploadAction() {
    let UPLOAD_API_URL = Setting.UPLOAD_API_URL;
    return `${UPLOAD_API_URL}/upload`
}



// 编辑合约
export function ModifyContract(data) {
    return request({
        url: '/chainmaker?cmb=ModifyContract',
        method: 'post',
        data
    });
}


// 根据Id获取合约详情
export function ContractDetail(data) {
    return request({
        url: '/chainmaker?cmb=ContractDetail',
        method: 'post',
        data
    });
}

// 获取投票组织列表(当前用户的链上组织列表)
export function GetCertOrgList(data) {
    return request({
        url: '/netmanagement/net/getUserOrgList',
        method: 'post',
        data
    });
}


// 获取投票管理列表
export function GetVoteManageList(data) {
    return request({
        url: '/netmanagement/net/getOrgVoteInfoList',
        method: 'post',
        data
    });
}

// 获取投票详情信息
export function GetVoteDetail(data) {
    return request({
        url: '/netmanagement/net/getVoteDetail',
        method: 'post',
        data
    });
}

// 投票
export function Vote(data) {
    return request({
        url: '/netmanagement/net/doVote',
        method: 'post',
        data
    });
}

// 发起多签
export function MultiSign(data) {
    return request({
        url: '/netmanagement/net/multiSign',
        method: 'post',
        data
    });
}


// 获取投票信息列表
export function GetOrgVoteInfoList(data) {
    return request({
        url: '/netmanagement/net/getOrgVoteInfoList',
        method: 'post',
        data
    });
}


// 获取上链管理 - 合约列表
export function GetInvokeContractList(data) {
    return request({
        url: '/chainmaker?cmb=GetInvokeContractList',
        method: 'post',
        data
    });
}

// 获取上链管理列表
export function GetInvokeRecordList(data) {
    return request({
        url: '/chainmaker?cmb=GetInvokeRecordList',
        method: 'post',
        data
    });
}

// 发起上链
export function InvokeContract(data) {
    return request({
        url: '/chainmaker?cmb=InvokeContract',
        method: 'post',
        data
    });
}

// 新建区块链
export function AddChain(data) {
    return request({
        url: '/chainmaker?cmb=AddChain',
        method: 'post',
        data
    });
}

// 新建区块链 - 判断chainid和chainname是否被占用
export function ValidateChain(data) {
    return request({
        url: '/chainmaker?cmb=ValidateChain',
        method: 'post',
        data
    });
}

// { "Tls": 0, 
// "ChainId": "chain1", 
// "ChainName": "chain1", 
// "BlockTxCapacity": 100,
//  "BlockInterval": 2000, 
//  "TxTimeout": 600, 



//  "Consensus": 1, 
// "ChainmakerImprove": 1,
// "DockerVm": 0 
// "Monitor": 0, 

//  "Nodes": [{ "OrgId": "org1", "NodeList": "node11,node12" }, 
//  { "OrgId": "org2", "NodeList": "node21,node22" }], 
//   }

// {NodeName: "dddd", NodeRpcPort: 21000, NodeP2pPort: 21001, NodeIp: "192.168.0.92"}

// Single: 0 / 1 


// Tls: 0
// ChainId: "sdf"
// ChainName: "sdf"
// TxTimeout: 600
// BlockInterval: 2000
// BlockTxCapacity: 100

// Consensus: 0
// ChainmakerImprove: 1

// DockerVm: 0
// Monitor: 0
// Nodes: [{OrgId: "ggg",…}]



// 获取共识策略
export function GetConsensusList(data) {
    return request({
        url: '/chainmaker?cmb=GetConsensusList',
        method: 'post',
        data
    });
}

// 获取节点信息
export function GetCertNodeList(data) {
    return request({
        url: '/chainmaker?cmb=GetCertNodeList',
        method: 'post',
        data
    });
}

// 获取日志级别
export function GetNodeLogLevel(data) {
    return request({
        url: '/chainmaker?cmb=GetNodeLogLevel',
        method: 'post',
        data
    });
}

// 获取认证用户列表（订阅链）
export function GetCertUserList(data) {
    return request({
        url: '/chainmaker?cmb=GetCertUserList',
        method: 'post',
        data
    });
}

// 获取订阅链初始化数据
export function GetSubscribeConfig(data) {
    return request({
        url: '/chainmaker?cmb=GetSubscribeConfig',
        method: 'post',
        data
    });
}





// 删除区块链
// export function DeleteChain(data) {
//     return request({
//         url: '/chainmaker?cmb=DeleteChain',
//         method: 'post',
//         data
//     });
// }

// 获取区块链列表
// export function GetChainList(data) {
//     return request({
//         url: '/chainmaker?cmb=GetChainList',
//         method: 'post',
//         data
//     });
// }

// export function GetChainList(data) {
//     return request({
//         url: '/explorer/getChainList',
//         method: 'get',
//         data
//     });
// }

export function GetChainListExplorer(data) {
    return request({
        url: '/explorer/getChainList',
        method: 'get',
        data
    });
}

export function GetChainList(data) {
    return request({
        url: '/netmanagement/net/getchainlist',
        method: 'get',
        data
    });
}

// 获取关键指标
// export function GeneralData(data) {
//     return request({
//         url: '/chainmaker?cmb=GeneralData',
//         method: 'post',
//         data
//     });
// }
export function GeneralData(data) {
    return request({
        url: '/explorer/getDecimal',
        method: 'post',
        data
    });
}

// 近24小时交易统计
// export function GetTransactionNumByTime(data) {
//     return request({
//         url: '/chainmaker?cmb=GetTransactionNumByTime',
//         method: 'post',
//         data
//     });
// }
export function GetTransactionNumByTime(data) {
    return request({
        url: '/explorer/getTransactionNumByTime',
        method: 'post',
        data
    });
}

// 获取区块列表
// export function GetBlockList(data) {
//     return request({
//         url: '/chainmaker?cmb=GetBlockList',
//         method: 'post',
//         data
//     });
// }
export function GetBlockList(data) {
    return request({
        url: '/explorer/getBlockList',
        method: 'post',
        data
    });
}

// 获取节点列表
// export function GetNodeList(data) {
//     return request({
//         url: '/chainmaker?cmb=GetNodeList',
//         method: 'post',
//         data
//     });
// }
export function GetNodeList(data) {
    return request({
        url: '/explorer/getNodeList',
        method: 'post',
        data
    });
}

// 获取交易列表信息
// export function GetTxList(data) {
//     return request({
//         url: '/chainmaker?cmb=GetTxList',
//         method: 'post',
//         data
//     });
// }
export function GetTxList(data) {
    return request({
        url: '/explorer/getTxList',
        method: 'post',
        data
    });
}

// 获取用户列表
// export function GetChainUserList(data) {
//     return request({
//         url: '/chainmaker?cmb=GetChainUserList',
//         method: 'post',
//         data
//     });
// }
export function GetChainUserList(data) {
    return request({
        url: '/explorer/getUserList',
        method: 'post',
        data
    });
}

// 获取合约列表
// export function GetContractList(data) {
//     return request({
//         url: '/chainmaker?cmb=GetContractList',
//         method: 'post',
//         data
//     });
// }
export function GetContractList(data) {
    return request({
        url: '/explorer/getContractList',
        method: 'post',
        data
    });
}

// 获取组织列表
// export function GetOrgList(data) {
//     return request({
//         url: '/chainmaker?cmb=GetOrgList',
//         method: 'post',
//         data
//     });
// }
export function GetOrgList(data) {
    return request({
        url: '/explorer/getOrgList',
        method: 'post',
        data
    });
}

// 获取区块详情
// export function GetBlockDetail(data) {
//     return request({
//         url: '/chainmaker?cmb=GetBlockDetail',
//         method: 'post',
//         data
//     });
// }
export function GetBlockDetail(data) {
    return request({
        url: '/explorer/getBlockDetail',
        method: 'post',
        data
    });
}

// 获取合约详情
// export function GetContractDetail(data) {
//     return request({
//         url: '/chainmaker?cmb=GetContractDetail',
//         method: 'post',
//         data
//     });
// }
export function GetContractDetail(data) {
    return request({
        url: '/explorer/getContractDetail',
        method: 'post',
        data
    });
}

// 获取交易详情
// export function GetTxDetail(data) {
//     return request({
//         url: '/chainmaker?cmb=GetTxDetail',
//         method: 'post',
//         data
//     });
// }
export function GetTxDetail(data) {
    return request({
        url: '/explorer/getTxDetail',
        method: 'post',
        data
    });
}

// 获取节点详情
// export function GetNodeDetail(data) {
//     return request({
//         url: '/chainmaker?cmb=GetNodeDetail',
//         method: 'post',
//         data
//     });
// }
export function GetNodeDetail(data) {
    return request({
        url: '/explorer/getNodeDetail',
        method: 'post',
        data
    });
}

// 区块浏览器查询（ 区块哈希 / 区块高度 / 交易ID / 合约名称 ）
// export function HomePageSearch(data) {
//     return request({
//         url: '/chainmaker?cmb=HomePageSearch',
//         method: 'post',
//         data
//     });
// }
export function HomePageSearch(data) {
    return request({
        url: '/explorer/homepageSearch',
        method: 'post',
        data
    });
}

// 订阅链
export function SubscribeChain(data) {
    return request({
        url: '/netmanagement/net/subscribe',
        method: 'post',
        data
    });
}



// 获取合约管理列表
export function GetContractManageList(data) {
    return request({
        url: '/netmanagement/contract/getcontractlist',
        method: 'post',
        data
    });
}

// 获取管理列表合约详情
export function GetContractManageDetail(data) {
    return request({
        url: '/netmanagement/contract/getcontract?id=' + data.id,
        method: 'get'
    });
}

// 获取合约交易列表
export function GetContractTransactionList(data) {
    return request({
        url: '/netmanagement/contract/gettransactionlist',
        method: 'post',
        data
    });
}

// 获取合约事件列表
export function GetContractEventList(data) {
    return request({
        url: '/netmanagement/contract/geteventlist',
        method: 'post',
        data
    });
}

// 获取合约操作记录列表
export function GetContractOperationLogList(data) {
    return request({
        url: '/netmanagement/contract/getoperationloglist',
        method: 'post',
        data
    });
}

// 部署合约
// export function InstallContract(data) {
//     return request({
//         url: '/chainmaker?cmb=InstallContract',
//         method: 'post',
//         data
//     });
// }

// {"ContractName":"aa",
// "ContractVersion":"aa",
// "RuntimeType":2,
// "CompileSaveKey":"12.1.652bc8f4414e512bd61a53551fb8704fede6a2106dda785c92126fa1ac9a2b30",
// EvmAbiSaveKey: "17.1.652bc8f4414e512bd61a53551fb8704fede6a2106dda785c92126fa1ac9a2b30",
// "Reason":"部署理由",
// "Parameters":[{"Key":"key1","Value":"value1"},{"Key":"key2","Value":"value2"}],
// "Methods":[{"MethodName":"method1","MethodKey":"param1"},{"MethodName":"method2","MethodKey":"param2"}],
// "ChainId":"chain1"}

// export function InstallContract(data) {
//     return request({
//         url: '/netmanagement/contract/install',
//         method: 'post',
//         data
//     });
// }

export function InstallContract(data) {
    return request({
        url: '/netmanagement/net/installContractVote',
        method: 'post',
        data
    });
}


// 升级合约
// export function UpgradeContract(data) {
//     return request({
//         url: '/netmanagement/contract/upgrade',
//         method: 'post',
//         data
//     });
// }
export function UpgradeContract(data) {
    return request({
        url: '/netmanagement/net/upgradeContractVote',
        method: 'post',
        data
    });
}

// 冻结合约
// export function FreezeContract(data) {
//     return request({
//         url: '/netmanagement/contract/freeze',
//         method: 'post',
//         data
//     });
// }
export function FreezeContract(data) {
    return request({
        url: '/netmanagement/net/freezeContractVote',
        method: 'post',
        data
    });
}

// 解冻合约
// export function UnFreezeContract(data) {
//     return request({
//         url: '/netmanagement/contract/unfreeze',
//         method: 'post',
//         data
//     });
// }
export function UnFreezeContract(data) {
    return request({
        url: '/netmanagement/net/unfreezeContractVote',
        method: 'post',
        data
    });
}

// 废弃合约
export function RevokeContract(data) {
    return request({
        url: '/netmanagement/net/revokeContractVote',
        method: 'post',
        data
    });
}

// 获取区块链详情信息
export function GetChainDetail(data) {
    return request({
        url: '/netmanagement/net/getchainconfig',
        method: 'post',
        data
    });
}

// 获取组织管理列表
export function GetOrgManageList(data) {
    return request({
        url: '/netmanagement/organdnode/getorglist',
        method: 'post',
        data
    });
}

// 链上新增组织
// export function chainAddOrg(data) {
//     return request({
//         url: '/netmanagement/organdnode/addorg',
//         method: 'post',
//         data
//     });
// }
export function chainAddOrg(data) {
    return request({
        url: '/netmanagement/net/addOrgVote',
        method: 'post',
        data
    });
}



// 获取节点管理列表
export function GetNodeManageList(data) {
    return request({
        url: '/netmanagement/organdnode/getnodelist',
        method: 'post',
        data
    });
}

// 获取链权限配置列表
export function GetAuthList(data) {
    return request({
        url: '/netmanagement/net/getpolicylist',
        method: 'post',
        data
    });
}

// 删除网络
export function DeleteChain(data) {
    return request({
        url: '/netmanagement/net/deletenet',
        method: 'post',
        data
    });
}

// 创建网络
export function CreateNet(data) {
    return request({
        url: '/netmanagement/net/createnet',
        method: 'post',
        data
    });
}

// 下载链配置文件
export function DownloadChainConfig(data) {
    return request({
        url: '/netmanagement/net/downloadchainconfig',
        method: 'post',
        data
    });
}

// 下载区块链配置文件
// export function DownloadChainConfig(data) {
//     return request({
//         url: '/chainmaker?cmb=DownloadChainConfig',
//         method: 'post',
//         headers: { 'content-type': 'application/x-www-form-urlencoded;charset=UTF-8' },
//         responseType: 'blob',  // 将返回数据的文件流转为blob格式
//         data
//     });
// }
// {ChainId: "chain1"}

// 策略管理列表
export function GetPolicyManageList(data) {
    return request({
        url: '/netmanagement/net/getpolicylist',
        method: 'post',
        data
    });
}


// 修改链配置
export function ModifyChainConfig(data) {
    return request({
        url: '/netmanagement/net/updateChainConfig',
        method: 'post',
        data
    });
}

// 启动链网络
export function StartNet(data) {
    return request({
        url: '/netmanagement/net/startnet',
        method: 'post',
        data
    });
}

// 修改投票策略
export function UpdateChainPolicyVote(data) {
    return request({
        url: '/netmanagement/net/updateChainPolicyVote',
        method: 'post',
        data
    });
}

// 新增共识节点
export function AddConsensusNode(data) {
    return request({
        url: '/netmanagement/net/addconsensusnodevote',
        method: 'post',
        data
    });
}

// 获取平台创建网络
export function GetNetsInPlatform(data) {
    return request({
        url: '/netmanagement/net/getnetsinplatform',
        method: 'get',
        data
    });
}

// 启动节点
export function StartNode(data) {
    return request({
        url: '/netmanagement/net/startnode',
        method: 'POST',
        data
    });
}

// 停止节点
export function StopNode(data) {
    return request({
        url: '/netmanagement/net/stopnode?nodeId=' + data.nodeId,
        method: 'get'
    });
}

// 重启节点
export function RestartNode(data) {
    return request({
        url: '/netmanagement/net/restartnode?nodeId=' + data.nodeId,
        method: 'get'
    });
}

// 删除节点
export function DelNode(data) {
    return request({
        url: '/netmanagement/net/deleteconsensusnodevote',
        method: 'post',
        data
    });
}

// 刷新节点链配置
export function RefreshChainConfig(data) {
    return request({
        url: '/orgmanagement/node/refreshchainlist',
        method: 'post',
        data
    });
}

// 清退链上组织
export function DelChainOrg(data) {
    return request({
        url: '/netmanagement/net/deletechainorgvote',
        method: 'post',
        data
    });
}

// 导入已有网络
export function ImportChainConf(data) {
    return request({
        url: '/netmanagement/net/importchainconf',
        method: 'post',
        data
    });
}
